﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';

function landlordPeopleOrganizationsFilter(context) {
  const userTypeSelect = context.querySelector(".landlordpeopleorganizationspage__filter select");
  const freeTextInput = context.querySelector(".landlordpeopleorganizationspage__filter input");

  const listItemsWrapper = context.querySelector(".landlordpeopleorganizationspage__list");
  const listItemsWrapperClone = listItemsWrapper.cloneNode(true);

  function init() {
    userTypeSelect.addEventListener('change', filter);
    freeTextInput.addEventListener('keyup', debounce(filter, 300));

    if (userTypeSelect.value.length > 0 || freeTextInput.value.length > 0) {
      filter();
    }
  }

  function filter() {
    // console.log('filter')
    // const listItemsToSearch = eventType === 'usertype' ? listItemsWrapperClone.cloneNode(true) : listItemsWrapper.cloneNode(true);

    const userTypeAttribute = userTypeSelect.value.length === 0 ? '' : `="${userTypeSelect.value}"`;
    const listItemsToSearch = listItemsWrapperClone.cloneNode(true);
    const listItemsContainingValue = listItemsToSearch.querySelectorAll(`li[data-user-type${userTypeAttribute}]`);

    listItemsWrapper.innerHTML = '';

    listItemsContainingValue.forEach(item => {
      if (freeTextInput.value.length === 0) {
        listItemsWrapper.appendChild(item);
        return;
      }

      const textQuery = freeTextInput.value.toUpperCase();
      const searchableContent = item.querySelector('.left');
      const searchableContentText = searchableContent.innerText.toUpperCase();

      if (searchableContentText.indexOf(textQuery) !== -1) {
        listItemsWrapper.appendChild(item);
      }
    });

    listItemsWrapper.setAttribute('data-items', 10);
    freeTextInput.removeAttribute('aria-busy');
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      freeTextInput.setAttribute('aria-busy', 'true');

      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  return {
    init
  };
}

controller.add('landlord-people-organization-filter', landlordPeopleOrganizationsFilter);